var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authority"},[_c('el-tree',{ref:"authorityTree",attrs:{"disabled":_vm.disabled,"data":_vm.authorityTree,"show-checkbox":"","node-key":"id","props":_vm.defaultProps}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }